import type { FunctionComponent } from "react";
import type React from "react";
import { StyledContainer } from "./style";

interface TextFieldWrapperProps {
  children: React.ReactNode;
}

export const TextFieldWrapper: FunctionComponent<TextFieldWrapperProps> = ({
  children,
}) => {
  return <StyledContainer>{children}</StyledContainer>;
};
